import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux'

import { Checkbox, Table } from 'rsuite'
import SectionHeader from '../CommonComponents/SectionHeader';
import LoaderComponent from '../CommonComponents/LoaderComponent';
import QaNotesModal from './modals/qa-notes-modal';
import { toast } from '../CommonComponents/ToastComponent/toast';
import QAList from '../MyListsComponent/listInformationModal/qaList';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { getMatchedChildOrphans, getSuppliersDataByIds, rejectSuppliers } from '../../redux/actions/vendor';

const { Column, HeaderCell, Cell, Pagination } = Table

const AutoMatchedChildren = ({ isLoadingOrphans, matchedChildOrphans, totalMatchedChildRecords, limit, page, onChangePageHandler, handleChangeLimit, checkedKeys, checked, indeterminate, handleCheckAll, handleCheck, getMatchedChildren, setCheckedKeys, searchList, setSearchList, handleSubmitQA, selectedMatchedChildOrphans, setSelectedMatchedChildOrphans }) => {
    const [showRejectModal, setShowRejectModal] = useState(false)
    const [showQaListModal, setShowQaListModal] = useState(false)
    const [sortType, setSortType] = useState('asc')
    const [sortColumn, setSortColumn] = useState('id')
    const [flag, setFlag] = useState(0)

    const dispatch = useDispatch()

    const columns = [
        { name: 'suppliername', label: 'Supplier Name' },
        { name: 'autoDbmMatchScore', label: 'Matched Score' },
        { name: 'address1', label: 'Address' },
        { name: 'city', label: 'City' },
        { name: 'state', label: 'State' },
        { name: 'zip', label: 'Zip' },
        { name: 'acceptanceType', label: 'Acceptance Type' },
        { name: 'matchedSupplierName', label: 'Matched Supplier Name' },
        { name: 'matchedAddress1', label: 'Matched Address' },
        { name: 'matchedCity', label: 'Matched City' },
        { name: 'matchedState', label: 'Matched State' },
        { name: 'matchedZip', label: 'Matched Zip' }
    ]

    const headerColumns = () => {
        return columns.map((col) => {
            if (col.name === "autoDbmMatchScore") {
                return (
                    <Column
                        resizable
                        sortable={true}
                        key={col.name}
                    >
                        <HeaderCell className='text-black mb-0 fw-bold'>{col.label}</HeaderCell>
                        <Cell dataKey={col.name}>
                            {rowData => {
                                return (
                                    <p>{Math.round(rowData[col.name])}</p>
                                )
                            }}
                        </Cell>
                    </Column>
                )
            }

            if (col.name === "matchedSupplierName") {
                return (
                    <Column
                        resizable
                        sortable={true}
                        key={col.name}
                    >
                        <HeaderCell className='text-black mb-0 fw-bold'>{col.label}</HeaderCell>
                        <Cell dataKey={col.name}>
                            {rowData => {
                                return (
                                    <Link to={rowData?.matchedIsMaster ? `/suppliers/${rowData?.matchedSupplierId}` : `/suppliers/relatedsupplier/${rowData?.matchedSupplierId}`} target="_blank">{rowData[col.name]}</Link>
                                )
                            }}
                        </Cell>
                    </Column>
                )
            }
            return (
                <Column
                    resizable
                    sortable={true}
                    key={col.name}
                >
                    <HeaderCell className='text-black mb-0 fw-bold'>{col.label}</HeaderCell>
                    <Cell dataKey={col.name} />
                </Column>
            )
        })
    }

    const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
        <Cell {...props} style={{ padding: 0, display: 'flex', alignItems: 'center', margin: 0 }}>
            <Checkbox
                value={rowData[dataKey]}
                onChange={onChange}
                checked={checkedKeys.some(item => item === rowData[dataKey])}
            />
        </Cell>
    );

    const closeRejectModalHandler = () => {
        setShowRejectModal(false)
    }

    const onReject = async (editorState) => {
        if (checkedKeys?.length === 0) {
            toast.show({
                title: 'Warning',
                description: 'Please Select Supplier To Reject',
            })
            return
        }

        await dispatch(rejectSuppliers({ ids: checkedKeys })).then(async (res) => {
            toast.show({
                title: 'Success',
                description: 'Successfully Reject Suppliers',
            })
            await dispatch(getMatchedChildOrphans(1, 10, 0, {}, sortType, sortColumn))

            setCheckedKeys([])
            setSelectedMatchedChildOrphans([])
        }).catch(err => {
            return toast.show({
                title: 'Danger',
                description: 'Unable To Reject Selected Supplier',
            })
        })

        setCheckedKeys([])
        setSelectedMatchedChildOrphans([])

        getMatchedChildren(1, limit, 0)
    }

    const onApprove = async () => {
        if (checkedKeys?.length === 0) {
            toast.show({
                title: 'Warning',
                description: 'Please Select Supplier To Approve',
            })
            return
        }

        await handleSubmitQA(null, checkedKeys, 'approve', '', null, page = 'autoMatchedChildren')
        setCheckedKeys([])
        setSelectedMatchedChildOrphans([])

        getMatchedChildren(1, limit, 0)
    }

    const onClose = (refreshOrphanChildSups) => {
        setShowQaListModal(false)
        if (refreshOrphanChildSups) {
            getMatchedChildren(1, 10, 0, {})
        }
    }

    const handleSortColumn = (sortColumn, sortType) => {
        let matchedColumns = ['matchedSupplierName', 'matchedAddress1', 'matchedCity', 'matchedState', 'matchedZip', 'acceptanceType']
        let matchedColumnFound = matchedColumns.find(col => col === sortColumn)

        if (matchedColumnFound) {
            return
        }
        setSortColumn(sortColumn)
        setSortType(sortType)
        getMatchedChildren(1, 10, 0, {}, sortType, sortColumn)
    }

    useEffect(() => {
        checkedKeys.length > 0 && setFlag(1)
    }, [checkedKeys])

    const handleResetCheckedTableData = (id) => {
        const tmpCheckedIds = checkedKeys?.filter(key => key !== id)
        const tmpCheckedRows = selectedMatchedChildOrphans?.filter(data => data?.id !== id)
        setCheckedKeys(tmpCheckedIds)
        setSelectedMatchedChildOrphans(tmpCheckedRows)
    }

    return (
        <div className=' mt-5'>
            <div className='d-flex justify-content-between'>
                <SectionHeader title='Pending Suppliers' />
                {showRejectModal && <QaNotesModal
                    show={showRejectModal}
                    onClose={closeRejectModalHandler}
                    onDone={onReject}
                    page='auto-matched-children'
                    qaReject={false}

                />}
                {showQaListModal && <QAList
                    show={showQaListModal}
                    onGoBack={onClose}
                    allVendors={checkedKeys.length > 0 ? selectedMatchedChildOrphans : matchedChildOrphans}
                    page='autoMatchedChildren'
                    onApprove={onApprove}
                    onReject={onReject}
                    getMatchedChildren={getMatchedChildren}
                    checkedKeys={checkedKeys}
                    resetCheckedTableData={handleResetCheckedTableData}
                />}
                <div className='d-flex column-gap-3 '>
                    <button className='report_button_blue' disabled={matchedChildOrphans?.length === 0} onClick={() => { setShowQaListModal(true) }}>QA List</button>
                    <button className='report_button_danger' onClick={() => { onReject() }} disabled={checkedKeys.length === 0 && true}>Reject</button>
                    <button className='report_button_success' onClick={() => { onApprove() }} disabled={checkedKeys.length === 0 && true}>Approve</button>
                </div>
            </div>
            <div className={`record-body mt-5 border ${isLoadingOrphans ? 'loading' : ''}`}>
                {isLoadingOrphans && <LoaderComponent />}
                <Table
                    virtualized
                    autoHeight
                    affixHeader={true}
                    data={matchedChildOrphans}
                    sortType={sortType}
                    sortColumn={sortColumn}
                    onSortColumn={handleSortColumn}
                >
                    <Column width={50} align="center" >
                        <HeaderCell style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Checkbox
                                checked={checked}
                                indeterminate={indeterminate}
                                onChange={handleCheckAll}
                            />
                        </HeaderCell>
                        <CheckCell dataKey="id" checkedKeys={checkedKeys} onChange={handleCheck} />
                    </Column>
                    {headerColumns()}
                </Table>
                <div className="pagination">
                    <Pagination
                        prev
                        next
                        first
                        last
                        showInfo
                        maxButtons={5}
                        lengthMenu={[
                            {
                                label: '5',
                                value: 5,
                            },
                            {
                                label: '10',
                                value: 10,
                            },
                            {
                                label: '25',
                                value: 25,
                            },
                            {
                                label: '50',
                                value: 50,
                            },
                        ]}
                        displayLength={limit}
                        total={totalMatchedChildRecords}
                        limit={limit}
                        activePage={page}
                        onChangePage={(event) => { onChangePageHandler(event) }}
                        onChangeLength={handleChangeLimit}
                    />
                </div>
            </div>
        </div>
    );
}

export default AutoMatchedChildren;